export enum FeatureFlag {
  ANALYTICS = 'analytics',
  AI_REPORT_GENERATE_BUTTON = 'ai-report-generate-button',
  CSV_DATA_EXPORT = 'csv-data-export',
  RE_ASSIGN_OWNERSHIP_BUTTON = 're-assign-ownership-button',
  ASSISTANT = 'assistant',
  GLOBAL_KPIS_FACILITY_LEVEL = 'global-kpis-facility-level',
  LEGACY_EVALUATION_TAB = 'legacy-evaluation-tab',
  NARRATIVE_SUGGESTION = 'narrative-suggestion',
  NARRATIVE_MULTISTEP_SUGGESTION = 'narrative-multistep-suggestion',
  TRANSFORM_IROS = 'transform-iros',
  SUGGEST_DP_IRO = 'suggest-dp-iro',
  IRO_MIGRATION = 'iro-migration',
  SAML = 'saml',
  DATA_POINT_SOURCE_LINK = 'data-point-source-link',
  VALUE_CHAIN_IRO = 'value-chain-iro',
  DATA_POINT_SUGGESTION = 'data-point-suggestion',
  NEW_ASSISTANT = 'new-assistant',
  IRO_LIBRARY = 'iro-library',
  MOCK_REPORT_TEMPLATES = 'mock-report-templates',
  RECOMMENDATION_TEST_REPORT_TEMPLATE = 'recommendation-test-report-template',
  MAVUE_2 = 'mavue-2',
  JSON_EDITOR = 'json-editor',
  AI_REPORT_BUILDER = 'ai-report-builder',
  ECOVADIS = 'ecovadis',
  CHANGELOGS = 'changelogs',
  DEEP_RESEARCH_REPORT_BUILDER = 'deep-research-report-builder',
  REPORT_BUILDER = 'report-builder',
  PROJECTS = 'projects',
  ASSISTANT_V2 = 'assistant-v2',
  RECOMMENDATION_GENERATION_V2 = 'recommendation-generation-v2',
}
